import { trackAuthoringDraftGenerated } from '~/telemetry/usePostHog';

/**
 * Reports `authoring-draft-generated` once per new authoring session.
 *
 * A session is only expected to produce a first draft when it is started from
 * the setup screen (`createAuthoringConversation` called without an id). Every
 * later generation in the same document, and any document that is reopened or
 * duplicated, is not a first draft, so it must not be reported as one. The
 * expectation is cleared when it is reported, so a regeneration never counts.
 *
 * Conversation ids are only used here as keys and are never sent.
 */
const awaitingFirstDraft = new Set();

/** Call when a brand-new authoring session sends its first generation request. */
export const expectFirstDraft = (conversationId) => {
  if (conversationId) {
    awaitingFirstDraft.add(conversationId);
  }
};

/** Call when a generation's layouts have all been applied to the editor. */
export const reportFirstDraft = (conversationId) => {
  if (conversationId && awaitingFirstDraft.delete(conversationId)) {
    trackAuthoringDraftGenerated();
  }
};
